export default __webpack_public_path__ + "static/apk-btn-bg-630d4939539a90f26981b66028f51479.png";